import React from 'react'

export const CorreoInscripcion = (props) => {
    if(props.idioma === "es"){
        return (
            <div>
                <p>Estimado Proveedor: {props?.proveedor}</p>
    
                <p>Apreciamos su comunicación y creemos sin duda que ésta será la clave para comenzar y mantener una excelente relación comercial entre ambas compañías, su colaboración lo convertirá en un importante aliado para nuestros procesos presentes y futuros.</p>
    
                <p>El enlace que a continuación se le comparte lo dirigirá hacia un formulario de inscripción de nuevos proveedores, por favor complete toda la información que allí se le solicita.  </p>
                
                <a href={`${process.env.REACT_APP_URL}${process.env.REACT_APP_ENV}/inscripcionProveedor/${props.idioma}/${props?.enlace}`} target='_blank' rel="noreferrer" >Has click aquí para ingresar al formulario.</a>
    
                <p>Para cualquier consulta, puede contactarnos al número {process.env.REACT_APP_NoTelefono}.</p>
    
                <p>*Un formulario incompleto hará que nuestro proceso de pago o compras se retrase.</p>
                <p>*Correo generado automáticamente, por favor no responder.</p>
    
    
                <p>Saludos cordiales.</p>
                <br />
    
            </div>
        )
    }else{
        return (
            <div>
                <p>Dear Supplier: {props?.proveedor}</p>

                <p>We appreciate your communication and strongly believe that it will be key to starting and maintaining an excellent business relationship between both companies. Your collaboration will make you an important ally in our current and future processes.</p>
                
                <p>The link below will direct you to a new supplier registration form. Please complete all the information requested.</p>
                
                <a href={`${process.env.REACT_APP_URL}${process.env.REACT_APP_ENV}/inscripcionProveedor/${props.idioma}/${props?.enlace}`} target='_blank' rel="noreferrer" >Click here to enter the form.</a>
    

                <p>For any inquiries, you can contact us at {process.env.REACT_APP_NoTelefono}.</p>

                <p>*An incomplete form will delay our payment or purchasing process.</p>
                <p>*This is an automatically generated email, please do not reply.</p>

                
                <p>Best regards.</p>
                <br />
    
            </div>
        )
    }
}